export const billingRouteNames = {
  billing: 'billing',
  changePaymentMethod: 'change-payment-method',
  changePaymentMethodDone: 'change-payment-method-done',
  changePlan: 'change-plan',
  confirmPlanChange: 'confirm-plan-change',
  cancelPlan: 'cancel-plan',
  renewPlan: 'renew-plan',
};
